import React from "react"
import { useGoogleLogin } from '@react-oauth/google'
import axios from "axios"

interface Props {
    csrfToken: string;
    setErrorMessage: (msg: string) => void;
    setLoading: (val: boolean) => void;
    onSuccess: ()=> void;
}

export default function SignInPartners( {csrfToken, setErrorMessage, setLoading, onSuccess}: Props){
    // Function to handle Google sign in
    const login = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            setLoading(true)
            const accessToken = tokenResponse.access_token;
            // API call to check user authenticity
            await axios.post(`${process.env.REACT_APP_SKILLJA_URL}/google/sign_in/`, { access_token: accessToken }, {
                headers: {
                    "X-CSRFToken": csrfToken,
                    "Content-Type": "application/json",
                    },
                    withCredentials: true,
                })
                .then((res) => {
                    if (res.status === 200) {
                        // user account was found
                        if(res.data?.user_exists){
                            // user has confirmed their account
                            if(res.data.user_active){
                                onSuccess()
                                return
                            }
                            else { 
                                // inactive user account
                                setErrorMessage("Your account has not been confirmed. Please check your email for a confirmation link!")
                                setLoading(false)
                            }
                        }
                        // user account does not exist
                        else {
                            setErrorMessage("An unexpected error occurred with your Google account. Please try again.")
                            setLoading(false)
                        }
                    }
                })
                .catch((error) => { 
                    // an issue occurred retrieving this users google account
                    console.error(error)
                    setErrorMessage("Something went wrong during sign-in. Please try again.")
                    setLoading(false)
                })
        },
        scope: 'email',
    })

    return (
        <div 
            className="bg-main-white w-full my-3 sign-in-partner-btn" onClick={()=>login()} 
            data-context="signin"
            data-ux_mode="redirect"
        >
            <img 
                src={require('../../assets/google-logo.png')} 
                className="w-8 ml-5 my-auto rounded-full" 
                role="button"
                aria-label="Sign in with Google"
            />
            <p className="text-main-black my-auto ml-2 mr-9 font-kulim">
                Sign in with Google
            </p>
        </div>
    )
}
